import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/images/logo.png'

const Logo = props => {
    return (
        <NavLink to="/" className="logo">
            <img src={logo} alt="Logo" />
        </NavLink>
    );
}

export default Logo;